import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/icons/hamburger.svg'
import _imports_1 from '@/assets/images/logo/logo-white.svg'
import _imports_2 from '@/assets/icons/hamburger-close.svg'
import _imports_3 from '@/assets/images/logo/logo.svg'


const _hoisted_1 = { class: "app-menu-bar" }
const _hoisted_2 = { class: "app-menu-bar__left" }
const _hoisted_3 = { class: "app-menu-bar__right" }
const _hoisted_4 = { class: "nav hide-mobile" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "app-menu-bar__dropdown-menu"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "mobile-menu hide-desktop"
}
const _hoisted_11 = { class: "mobile-menu__header" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_3,
  alt: "logo"
}, null, -1)
const _hoisted_13 = { class: "nav" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "mobile-menu__footer" }
const _hoisted_16 = { href: "#" }
const _hoisted_17 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBtn = _resolveComponent("UiBtn")!
  const _component_LocaleSwitch = _resolveComponent("LocaleSwitch")!
  const _component_LocaleSwitchMobile = _resolveComponent("LocaleSwitchMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "hamburger hide-desktop",
        src: _imports_0,
        alt: "asset",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen))
      }),
      _createElementVNode("img", {
        class: "logo",
        src: _imports_1,
        alt: "logo",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logoClick()))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hackHero()))
          }, [
            _createElementVNode("a", {
              href: item.href,
              class: _normalizeClass({ 'active': _ctx.$route.hash === item.href })
            }, _toDisplayString(item.label), 11, _hoisted_5)
          ]))
        }), 128))
      ]),
      _createElementVNode("ul", {
        ref: "signinMenu",
        class: "app-menu-bar__signin-menu",
        onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSigninHover(true))),
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSigninHover(false)))
      }, [
        _createElementVNode("li", null, [
          (_ctx.width > 600)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.URI_LOGIN
              }, _toDisplayString(_ctx.dict.signin), 9, _hoisted_6))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "app-menu-bar__signin-trigger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openSignin()))
              }, _toDisplayString(_ctx.dict.signin), 1))
        ]),
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (_ctx.isSigninExpanded)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: _ctx.URI_LOGIN }, [
                      _createVNode(_component_UiBtn, { class: "dropdown-menu__button" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.dict.signinMenu.patient), 1)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_8)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: _ctx.MYDR_EDM_LOGIN }, [
                      _createVNode(_component_UiBtn, { class: "dropdown-menu__button" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.dict.signinMenu.clinic), 1)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_9)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 544),
      _createVNode(_component_LocaleSwitch, { class: "hide-mobile" })
    ]),
    (_ctx.menuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "hamburger-close",
              src: _imports_2,
              alt: "asset",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen))
            }),
            _hoisted_12,
            _createVNode(_component_LocaleSwitchMobile, { class: "locale-switch-mobile" })
          ]),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.menuOpen = false))
              }, [
                _createElementVNode("a", {
                  href: item.href,
                  class: _normalizeClass({ 'active': _ctx.$route.hash === item.href })
                }, _toDisplayString(item.label), 11, _hoisted_14)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_UiBtn, {
                type: "register",
                class: "cta-btn",
                "default-icon": true,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.menuOpen = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dict.makeAppointment), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", { href: _ctx.URI_LOGIN }, [
              _createVNode(_component_UiBtn, {
                type: "search",
                class: "cta-btn",
                "default-icon": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dict.signin), 1)
                ]),
                _: 1
              })
            ], 8, _hoisted_17)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}